import React, { useRef } from 'react';

import Selector from './Selector';
import EditableTag from '../shared/EditableTag';
import { focusRef } from '../shared/EventHelpers';

const noLabel = {
    name: '(ingen)',
};

const EditSelectSearchable = ({ iconName, value, setValue, options, onSave, isInvalid, autoFocus, handleCancel }) => {
    const inputRef = useRef();

    const optionsWithNone = options && options.length ? [noLabel].concat(options) : null;

    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`input-wrapper ${isInvalid ? 'invalid' : ''}`} onClick={() => focusRef(inputRef)}>
                {value && <EditableTag label={value.name} handleDelete={() => setValue(null)} />}
                <Selector {...{ iconName, value, setValue, options: optionsWithNone, inputRef, onSave, autoFocus, handleCancel }} />
            </div>
        </div>
    );
};

export default EditSelectSearchable;
